// extracted by mini-css-extract-plugin
module.exports = {"title":"RecentSearch_title__e24vq","clear":"RecentSearch_clear__1YEYc"};